import React, {useMemo} from 'react';
import { Box } from '@mui/joy';
import { KPI } from '../../../../mtska-frontend-app-component';
import List from './List';

const Default = () => {

    return useMemo(() => <>
        <Box className="mtksa-chart-wrapper">
            <KPI
                title="Holding"
                icon="faBuildingColumns"
                dataProviderName={'statistics/holding/count/companies/legalEntity'}
                filters={{
                    'items': [{
                        'field': 'type',
                        'operator': 'equals',
                        'value': 'holding'
                    }]
                }}
            />
            <KPI
                title="Legal Entities"
                icon="faBuilding"
                dataProviderName={'statistics/total/count/companies/legalEntity'}
                filters={{
                    'items': [{
                        'field': 'type',
                        'operator': 'isNot',
                        'value': 'holding'
                    }]
                }}
            />
            <KPI
                title="Customers"
                icon="faCartShopping"
                dataProviderName={'statistics/customer/count/companies/legalEntity'}
                filters={{
                    'items': [{
                        'field': 'type',
                        'operator': 'equals',
                        'value': 'customer'
                    }]
                }}
            />
            <KPI
                title="Suppliers"
                icon="faTruckFast"
                dataProviderName={'statistics/supplier/count/companies/legalEntity'}
                filters={{
                    'items': [{
                        'field': 'type',
                        'operator': 'equals',
                        'value': 'supplier'
                    }]
                }}
            />
        </Box>
        <List />
    </>,[])

}

export default Default;


